<template>
  <svg
    :class="className"
    fill="none"
    :height="height"
    viewBox="0 0 44 44"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8 0.5H36C40.1421 0.5 43.5 3.85786 43.5 8V36C43.5 40.1421 40.1421 43.5 36 43.5H8C3.85786 43.5 0.5 40.1421 0.5 36V8C0.5 3.85786 3.85786 0.5 8 0.5Z" :fill="fill" :stroke="fill"/>
    <mask id="path-2-inside-1" fill="#F9F9F9">
      <rect height="18" rx="1" width="24" x="10" y="13"/>
    </mask>
    <rect height="18" mask="url(#path-2-inside-1)" rx="1" stroke="#F9F9F9" stroke-width="4" width="24" x="10" y="13"/>
    <circle cx="16" cy="19" fill="#F9F9F9" r="2"/>
    <path d="M29.9999 23.0857L26.2071 19.2929C25.8166 18.9024 25.1834 18.9024 24.7929 19.2929L20.2071 23.8787C19.8166 24.2692 19.1834 24.2692 18.7929 23.8787L17.7071 22.7929C17.3166 22.4024 16.6834 22.4024 16.2929 22.7929L14 25.0858V27.0858H29.9999V23.0857Z" fill="#F9F9F9"/>
  </svg>
</template>

<script>
export default {
  name: 'ImageControlQuality',
  props: {
    width: {
      type: String,
      required: false,
      default: '44'
    },
    height: {
      type: String,
      required: false,
      default: '44'
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
    fill: {
      type: String,
      required: false,
      default: '#000'
    },
  },
};
</script>
